import React, { useState } from "react";
import { ComponentOperationType } from "groopit-js/client";
import {
  createStyles,
  makeStyles,
  Menu,
  MenuItem,
  Theme,
} from "@material-ui/core";

interface ComponentOperationPickerProps {
  operationTypes: ComponentOperationType[];
  operation?: ComponentOperationType;
  onOperationChanged: (operation: ComponentOperationType) => void;
}

const getOperationName = (operation?: ComponentOperationType): string => {
  if (operation === undefined) return "any";

  switch (operation) {
    case ComponentOperationType.Any:
      return "any";
    case ComponentOperationType.None:
      return "blank";
    case ComponentOperationType.Equal:
      return "equal to";
    case ComponentOperationType.LessThan:
      return "less than";
    case ComponentOperationType.GreaterThan:
      return "greater Than";
    case ComponentOperationType.LessThanOrEqual:
      return "less than or equal to";
    case ComponentOperationType.GreaterThanOrEqual:
      return "greater than or equal to";
    case ComponentOperationType.Contains:
      return "or contains";
    case ComponentOperationType.AnyOf:
      return "any selected";
    case ComponentOperationType.AllOf:
      return "all selected";
    case ComponentOperationType.FollowUpComplete:
      return "follow up complete";
    case ComponentOperationType.FollowUpIncomplete:
      return "follow up incomplete";
  }
};

const useStandardStyles = makeStyles<Theme, ComponentOperationPickerProps>(
  (theme: Theme) =>
    createStyles({
      root: {
        color: (props) =>
          props.operation !== ComponentOperationType.Any
            ? theme.palette.primary.main
            : "inherit",
      },
    }),
);

export const ComponentOperationPicker = (
  props: ComponentOperationPickerProps,
) => {
  const { operationTypes, operation, onOperationChanged } = props;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const classes = useStandardStyles(props);

  return (
    <>
      <span
        className={`underline point-on-hover ${classes.root}`}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        {getOperationName(operation ?? ComponentOperationType.Any)}
      </span>
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        {operationTypes.map((op) => (
          <MenuItem
            key={op}
            value={op}
            onClick={() => {
              // Any really means "no filter" so drop the operation
              onOperationChanged(op);
              setAnchorEl(null);
            }}
          >
            {getOperationName(op)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
